import { useEffect, useState } from "react"
import { Button, Checkbox, Empty, Flex, Spin, Tabs } from "antd"
import { Alert } from "~/components/Alert"
import classNames from "classnames"
import { ResourcePreview } from "~/components/ResourcePreview"
import { Text } from "~/components/Text"
import styles from "./index.css"

const CATEGORIES = [
  { key: "F", label: "成年女性模特" },
  { key: "M", label: "成年男性模特" },
  { key: "C", label: "儿童模特" },
]
const getCategory = (value: string) => {
  const prefix = value.trim().charAt(0).toUpperCase()
  return CATEGORIES.some(({ key }) => key === prefix) ? prefix : "F"
}

type ModelFigureSelectProps = {
  items: API.Model.ModelFigure[]
  value: string
  status: "idle" | "loading" | "success" | "error"
  error: string
  onRetry: () => void
  onSelect: (modelId: string) => void
}

export const ModelFigureSelect = ({
  items,
  value,
  status,
  error,
  onRetry,
  onSelect,
}: ModelFigureSelectProps) => {
  const [category, setCategory] = useState(() => getCategory(value))
  useEffect(() => {
    if (value) setCategory(getCategory(value))
  }, [value])
  const models = items.filter((model) =>
    model.model_id.trim().toUpperCase().startsWith(category),
  )
  return (
    <Flex
      vertical
      gap={12}
    >
      {status === "idle" || status === "loading" ? (
        <Flex
          align="center"
          className={styles.centerState}
          gap={10}
          justify="center"
        >
          <Spin />
          <Text>正在加载系统模特...</Text>
        </Flex>
      ) : null}
      {status === "error" ? (
        <Alert
          action={
            <Button
              size="small"
              onClick={onRetry}
            >
              重试
            </Button>
          }
          description={error}
          showIcon
          title="系统模特加载失败"
          level="strong"
        />
      ) : null}
      {status === "success" ? (
        <>
          <Tabs
            activeKey={category}
            className={styles.modelTabs}
            items={CATEGORIES}
            onChange={setCategory}
          />
          {models.length ? (
            <Flex
              gap={12}
              wrap
            >
              {models.map((model) => (
                <Flex
                  className={classNames(
                    styles.modelCard,
                    value === model.model_id && styles.itemSelected,
                  )}
                  key={model.model_id}
                >
                  <Checkbox
                    aria-label={`选择${model.name || model.model_id}`}
                    checked={value === model.model_id}
                    className={styles.modelSelector}
                    onChange={() => onSelect(model.model_id)}
                  />
                  <ResourcePreview
                    type="image"
                    alt={model.name}
                    src={model.display_url}
                  />
                </Flex>
              ))}
            </Flex>
          ) : (
            <Empty
              description={`暂无${CATEGORIES.find(({ key }) => key === category)?.label || "系统模特"}`}
            />
          )}
        </>
      ) : null}
    </Flex>
  )
}
